import SchemaOrg from "@/components/feature/SchemaOrg";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function BrandIntro() {
  return (
    <section className="py-8 md:py-10">
      <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-5">
        品牌介绍
      </h2>
      <div className="prose prose-lg max-w-none text-foreground-700 leading-relaxed space-y-4">
        <p>
          51吃瓜网站成立于2024年，是国内领先的娱乐八卦内容聚合平台。我们致力于为吃瓜爱好者提供最新、最全、最优质的八卦内容和视频资源，让每一位用户都能在这里找到自己感兴趣的内容。
        </p>
        <p>
          平台聚焦每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列，通过专业的内容筛选和分类体系，帮助用户快速找到想看的内容。我们的编辑团队每天持续更新，确保内容的时效性和多样性。
        </p>
        <p>
          51吃瓜网始终坚持内容为王的原则，重视每一位用户的观看体验。我们不仅提供丰富的内容资源，还通过不断优化的平台功能和界面设计，为用户打造流畅便捷的使用体验。
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6 not-prose">
          {[
            { number: "2000+", label: "视频资源" },
            { number: "500万+", label: "月活跃用户" },
            { number: "6", label: "特色栏目" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="text-center p-5 bg-background-50 rounded-lg border border-background-200/60"
            >
              <div className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-rose-500 to-orange-500 bg-clip-text text-transparent">
                {stat.number}
              </div>
              <div className="text-sm text-foreground-600 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}